const getButtonType = (type) => {
  let color = "";
  switch (type) {
    case "":
    case null:
    case undefined:
    case "primary":
      color = "primary";
      break;
    case "secondary-a":
        color = "secondary black";
      break;
    case "secondary-b":
      color = "secondary purple";
      break;
    case "secondary-c":
      color = "secondary yellow";
      break;
    case "tertiary-a":
        color = "tertiary black";
      break;
    case "tertiary-b":
      color = "tertiary purple";
      break;
    case "tertiary-c":
      color = "tertiary yellow";
      break;
    case "special-a":
      color = "special black";
      break;
    case "special-b":
      color = "special purple";
      break;
  }
  return color;
};

const getIcon = (type) => {
  let icon = '';
  switch (type) {
    case 'send':
      icon = `<svg xmlns="http://www.w3.org/2000/svg" width="28.766" height="28.493" viewBox="0 0 28.766 28.493">
          <path id="send" d="M23.474,11.995,4.585,3.105A1.111,1.111,0,0,0,3.033,4.38L5.188,13l-2.155,8.62A1.111,1.111,0,0,0,4.585,22.9l18.89-8.889a1.112,1.112,0,0,0,0-2.011ZM5.757,19.886l.932-3.73L13,13,6.689,9.845l-.932-3.73L20.391,13Z" transform="matrix(0.819, -0.574, 0.574, 0.819, -4.179, 11.372)" />
        </svg>`;
      break;
    case 'trash':
      icon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
          <g id="trash" data-name="Grupo 8357" transform="translate(-268 -5094)">
            <path id="Trazado_510" data-name="Trazado 510" d="M17,20V8H7V20ZM13,10h2v8H13ZM9,10h2v8H9ZM9,4h6V6H9Z" transform="translate(264.997 5092)" fill="none"/>
            <path id="Trazado_511" data-name="Trazado 511" d="M5,20a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V8h2V6H17V4a2,2,0,0,0-2-2H9A2,2,0,0,0,7,4V6H3V8H5V20ZM9,4h6V6H9ZM8,8h9V20H7V8Z" transform="translate(264.997 5092)" />
            <path id="Trazado_512" data-name="Trazado 512" d="M9,10h2v8H9Zm4,0h2v8H13Z" transform="translate(264.997 5092)" />
          </g>
        </svg>
    `;
      break;
  }

  return icon;
}

export { getButtonType, getIcon };
